"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectExportFile = void 0;
const ExportFile_1 = require("../types/ExportFile");
function selectExportFile() {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        input.addEventListener('change', () => {
            var _a;
            const file = (_a = input.files) === null || _a === void 0 ? void 0 : _a[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        resolve(ExportFile_1.exportFileSchema.parse(JSON.parse(reader.result)));
                    }
                    catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = () => {
                    reject(new Error('Error reading file'));
                };
                reader.readAsText(file);
            }
            else {
                resolve(undefined);
            }
        });
        input.addEventListener('cancel', () => {
            resolve(undefined);
        });
        input.click();
    });
}
exports.selectExportFile = selectExportFile;
